import React from 'react'
import { Col, Form, Select, TimePicker } from 'antd'
import { WEEKDAY_OPTIONS } from '../../utils/cronSchedule'

const { Option } = Select

const CronScheduleFields = ({ dayColSpan = 12, timeColSpan = 12 }) => {
    return (
        <>
            <Col md={dayColSpan}>
                <Form.Item
                    name="dias_semana"
                    label={<span className="tx-pink font-bold">Dias da semana</span>}
                    rules={[
                        { required: true, message: 'Selecione ao menos um dia' },
                        {
                            validator: (_, value) => {
                                if (Array.isArray(value) && value.length > 0) {
                                    return Promise.resolve()
                                }
                                return Promise.reject(new Error('Selecione ao menos um dia'))
                            }
                        }
                    ]}
                >
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Selecione os dias"
                        optionFilterProp="children"
                    >
                        {WEEKDAY_OPTIONS.map((day) => (
                            <Option key={day.value} value={day.value}>
                                {day.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
            <Col md={timeColSpan}>
                <Form.Item
                    name="horario"
                    label={<span className="tx-pink font-bold">Horário</span>}
                    rules={[{ required: true, message: 'Informe o horário' }]}
                >
                    <TimePicker
                        format="HH:mm"
                        minuteStep={1}
                        style={{ width: '100%' }}
                        placeholder="Selecione o horário"
                    />
                </Form.Item>
            </Col>
        </>
    )
}

export default CronScheduleFields
